import React from 'react'
import * as moment from 'moment'

const Index = ({login}) => {

    const formatted_date = timestamp => {
        return moment(timestamp * 1000).format("HH:MM DD/MM/YYYY")
    }

	return(
		<tr key={login.id}>
			<td>{formatted_date(login.timestamp)}</td>
			<td>{`${login.city}, ${login.country}`}</td>
			<td><span className="status">{login.isp}</span></td>
            <td>{login.query}</td>
	</tr>
	)
}

export default Index